import {
  GET_PROVEEDORES_REQUEST,
  GET_PROVEEDORES_SUCCESS,
  RESET_PROVEEDORES,
} from '../../actions/constants/proveedores/proveedores.constants';

const initialState = {
  loading: false,
  listado: [],
  total: 0,
  page: 1,
  start: 0,
  limit: 25,
  sede: null,
  estado: false,
  tipoListado: 'listar',
  proveedoresSeleccionados: [],
};

export default function proveedoresReducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_PROVEEDORES_REQUEST: {
      return {
        ...state, loading: true,
      };
    }

    case GET_PROVEEDORES_SUCCESS: {
      const {
        datos, total, page, start, limit,
      } = payload;
      const { listado } = state;
      return {
        ...state, listado: [...listado, ...datos], total, loading: false, page, start, limit,
      };
    }

    case RESET_PROVEEDORES: {
      return {
        ...state, page: 1, start: 0, total: 25, listado: [],
      };
    }

    default:
      return state;
  }
}
